/* WEAVEPLACE — overlay/sticky state for Dawn's existing header.
   v2.3: start transparent transition immediately when mobile drawer closing is requested.
*/
(() => {
  'use strict';

  const init = () => {
    const section = document.querySelector('.section-header');
    const header = section?.querySelector('.header');
    const main = document.getElementById('MainContent');
    if (!section || !header || !main) return;

    const isHome = main.dataset.template === 'index';
    document.body.classList.toggle('wp-home', isHome);
    if (!isHome) return;

    const sizeHeader = () => {
      document.documentElement.style.setProperty('--wp-header-height', `${section.offsetHeight}px`);
    };
    sizeHeader();
    if ('ResizeObserver' in window) {
      new ResizeObserver(sizeHeader).observe(section);
    } else {
      window.addEventListener('resize', sizeHeader, { passive: true });
    }

    let previousY = window.scrollY;
    let movingUp = false;
    let hovered = false;
    let focused = false;
    let mobileDrawerClosing = false;

    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
    const menuIsOpen = () => Boolean(section.querySelector(
      'header-menu details[open], .header__inline-menu details[open], header-drawer details[open], details-modal details[open]'
    ));

    const update = () => {
      // On touch/mobile, Dawn returns focus to the hamburger summary after closing.
      // Focus alone must NOT keep the header white when the drawer is closed.
      const desktopInteraction = !isMobile() && (hovered || focused);
      const drawerIsOpen = mobileDrawerClosing && isMobile() ? false : menuIsOpen();
      const solid = desktopInteraction || drawerIsOpen || (window.scrollY > 8 && movingUp);
      section.classList.toggle('wp-header--solid', solid);
    };

    const onScroll = () => {
      const y = Math.max(0, window.scrollY);
      if (Math.abs(y - previousY) > 3) movingUp = y < previousY;
      if (y <= 8) movingUp = false;
      previousY = y;
      update();
    };

    section.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
        hovered = true;
        update();
      }
    });
    section.addEventListener('pointerleave', () => {
      hovered = false;
      update();
    });
    section.addEventListener('focusin', () => {
      focused = true;
      update();
    });
    section.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        focused = section.contains(document.activeElement);
        update();
      });
    });

    // Dawn can keep details[open] until the closing animation finishes.
    // Start the header color transition on the closing click instead.
    section.querySelectorAll('header-drawer details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;
      summary.addEventListener('click', () => {
        if (!isMobile()) return;
        mobileDrawerClosing = details.open;
        update();
      });
    });

    // Dawn may set/remove the open attribute after its menu animation.
    // Watching the actual drawer state avoids a stale white header.
    section.querySelectorAll('header-drawer details, details-modal details, header-menu details').forEach((details) => {
      new MutationObserver(() => {
        if (!details.open && details.closest('header-drawer')) mobileDrawerClosing = false;
        update();
      }).observe(details, { attributes: true, attributeFilter: ['open'] });
    });
    section.addEventListener('toggle', update, true);
    document.addEventListener('click', () => requestAnimationFrame(update));
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
